import React from 'react';
import { Autocomplete, TextField } from '@mui/material';

const defaultGetOptionLabel = (option) => {
  if (option === null || option === undefined) return '';
  if (typeof option === 'string' || typeof option === 'number') return String(option);
  return String(option.label || option.name || option.display_name || option.title || option.value || '');
};

const defaultGetOptionValue = (option) => {
  if (option === null || option === undefined) return '';
  if (typeof option === 'string' || typeof option === 'number') return option;
  return option.value ?? option.id ?? option.key ?? option.org_code ?? '';
};

export default function SearchableSelect({
  label,
  value,
  onChange,
  options = [],
  getOptionLabel = defaultGetOptionLabel,
  getOptionValue = defaultGetOptionValue,
  helperText,
  error,
  required = false,
  disabled = false,
  placeholder,
  textFieldProps,
  ...rest
}) {
  const selectedOption =
    options.find((option) => String(getOptionValue(option)) === String(value ?? '')) || null;

  return (
    <Autocomplete
      options={options}
      value={selectedOption}
      disabled={disabled}
      getOptionLabel={getOptionLabel}
      isOptionEqualToValue={(option, selected) =>
        String(getOptionValue(option)) === String(getOptionValue(selected))
      }
      onChange={(_, option) => onChange?.(option ? getOptionValue(option) : '')}
      renderInput={(params) => (
        <TextField
          {...params}
          {...textFieldProps}
          label={label}
          required={required}
          error={Boolean(error)}
          helperText={error || helperText}
          placeholder={placeholder}
        />
      )}
      {...rest}
    />
  );
}
